/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "fac",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "pool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "lowPt",
                type: "int24",
            },
        ],
        name: "swapX2Y",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "x",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "y",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapX2YCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "desireY",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapX2YDesireY",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "desireY",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapX2YDesireYNotPayEnough",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "lowPt",
                type: "int24",
            },
        ],
        name: "swapX2YNotPayEnough",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapY2X",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "x",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "y",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapY2XCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "desireX",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapY2XDesireX",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "desireX",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapY2XDesireXNotPayEnough",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
        ],
        name: "swapY2XNotPayEnough",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestSwap__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(fac, overrides) {
        return super.deploy(fac, overrides || {});
    }
    getDeployTransaction(fac, overrides) {
        return super.getDeployTransaction(fac, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestSwap__factory.bytecode = _bytecode;
TestSwap__factory.abi = _abi;
